import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getBlogPostById } from '../../utils/firestore';
import HeroSection from '../../components/common/HeroSection';

const BlogDetail = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const postData = await getBlogPostById(id);
        if (postData) {
          setPost(postData);
        } else {
          setError('Blog post not found');
        }
      } catch (err) {
        setError('Failed to load blog post');
        console.error('Error fetching blog post:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-nihal-primary"></div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="w-full section-padding bg-white">
        <div className="container">
          <div className="text-center py-12">
            <h1 className="text-3xl font-bold text-nihal-dark mb-4">Blog Yazısı Bulunamadı</h1>
            <p className="text-gray-600">{error || 'The requested blog post does not exist.'}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      {/* Page Header 
      <HeroSection 
        title="Nutrition Blog" 
        subtitle="Insights and tips for healthy living" 
      />
	*/}
      <div className="section-padding bg-white">
        <div className="container max-w-4xl">
          {post && (
            <motion.article
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6 }}
              className="bg-white rounded-lg shadow-md overflow-hidden"
            >
              <img 
                src={post.image || '/placeholder-image.jpg'} 
                alt={post.title} 
                className="w-full h-96 object-cover"
              />
              
              <div className="p-6 md:p-8">
                <div className="flex flex-wrap items-center gap-4 mb-6">
                  <span className="inline-block px-3 py-1 bg-nihal-primary text-white text-sm rounded-full">
                    {post.category}
                  </span>
                  <span className="text-sm text-gray-500">
                    {new Date(post.createdAt?.toDate()).toLocaleDateString()}
                  </span>
                </div>
                
                <h1 className="text-3xl md:text-4xl font-bold text-nihal-dark mb-6">{post.title}</h1>
                
                <div className="prose max-w-none text-gray-700 mb-8">
                  <div dangerouslySetInnerHTML={{ __html: post.content }} />
                </div>
                
                {/* Tags */}
                {post.tags && post.tags.length > 0 && (
                  <div className="mt-8">
                    <h3 className="text-lg font-bold text-nihal-dark mb-3">Etiketler:</h3>
                    <div className="flex flex-wrap gap-2">
                      {post.tags.map((tag, index) => (
                        <span 
                          key={index} 
                          className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                
                {/* Share buttons */}
                <div className="mt-12 pt-8 border-t border-gray-200">
                  <h3 className="text-lg font-bold text-nihal-dark mb-4">Yazıyı Paylaş</h3>
                  <div className="flex space-x-4">
                    
                    
                    <a 
                      href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 bg-blue-700 rounded-full flex items-center justify-center text-white hover:bg-blue-800 transition-colors"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </div>
                </div>
              </div>
            </motion.article>
          )}
          
          {/* Related posts would go here */}
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;